module.exports = __webpack_public_path__ + "img/arrows-right.48efbae7.png";